
export interface GetPriceRequest {
  space_id: number
  rent_type: number
  begin_time: string
  end_time: string
  accessory_ids: number[]
  rent_group: string
}
interface GetPriceResponse {
  amount: number
  estimated_amount: number
}

export const getPriceSSR = (spaceId: number, rentType: number, beginTime: string, endTime: string, accessoryIds: number[], rent_group: string): Promise<GetPriceResponse> => {
  return $fetch<GetPriceResponse>('/api/order/get-price', {
    method: 'POST',
    body: {
      space_id: spaceId,
      rent_type: rentType,
      begin_time: beginTime,
      end_time: endTime,
      accessory_ids: accessoryIds,
      rent_group: rent_group
    } as GetPriceRequest
  })
}